import { getAllSnapshotsNames } from "../s3/GetSnapshotsNames";

/* 
  Uploads a new CSV to S3 
  < input = S3 cognito credentials, filename and csvData >
*/

export async function CreateNewCSV(S3, fileName, csvData) {
  // S3 bucket and fileName initialisation
  const bucket = process.env.REACT_APP_S3_BUCKET;
  let snapshotNames = await getAllSnapshotsNames(S3);
  console.log("newName in creation: ",fileName)

  // Filter out empty rows and columns
  const rows = csvData.split("\n");
  const filteredRows = rows.filter((row) => {
    return row.trim() !== "" && row.split(",").some((col) => col.trim() !== "");
  });
  // Join the filtered rows back together with line breaks
  const filteredCSVData = filteredRows.join("\n");

    // Check if there are snapshots with the same name as fileName
    if (snapshotNames.includes(fileName + ".csv")) {
      console.error(
        "Snapshot with the same name already exists:",
        fileName
      );
      throw new Error("Duplicate Error");
    }

    // Save the CSV as there are no duplicates
    const csvKey =
      localStorage.getItem("s3Link") + "/Forms/Snapshots/" + fileName + ".csv";
    try {
      const uploadResponse = await S3.upload({
        Bucket: bucket,
        Key: csvKey,
        Body: filteredCSVData,
        Tagging: `status=In%20Progress&uploadedBy=${localStorage.getItem(
          "email"
        )}`,
      }).promise();

      // Console Testing
      console.log("Snapshot uploaded successfully:", uploadResponse);
      return fileName;
    } catch (error) {
      console.error("Error saving snapshot for later:", error);
      throw new Error("UploadError");
    }
  }

